import React from 'react'

export const Card = ({
    task
}) => {
    const { label, description, image } = task;
    return (
        <div className='flex flex-col w-[284px] justify-self-center self-start'>
            <div
                className='image-box'
                style={{backgroundImage: `url(${image})`}}
                />
            <h5 className='font-semibold text-lg'>{label}</h5>
            <p className='text-lg text-neutral-500'>{description}</p>
        </div>
    )
}
